module.exports = __webpack_public_path__ + "img/allowWindowOpen.ebbcb03f.png";